module.exports = __webpack_public_path__ + "static/media/1.2f470301.jpg";